import React, {
  FunctionComponent,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { SelectProps } from './Select.types';
import { InputContainer } from '../InputContainer/InputContainer';
import { TooltipIcon } from '../TooltipIcon';

export const Select: FunctionComponent<SelectProps> = props => {
  const { id, value, label, tooltip, onFocus, onBlur, ...rest } = props;
  const [active, setActive] = useState(!!value);

  const setActiveIfValue = useCallback(
    (value: string | undefined) => {
      if (value && !active) {
        setActive(true);
      }
    },
    [active],
  );

  useEffect(() => {
    setActiveIfValue(value);
  }, [value, setActiveIfValue]);

  return (
    <InputContainer className={`ui-input ${active ? '-active' : ''}`}>
      {label && (
        <div>
          <label htmlFor={id}>{label}</label>
        </div>
      )}
      <select
        {...rest}
        placeholder="Select one"
        id={id}
        data-testid={id}
        value={value}
        onFocus={e => {
          setActive(true);
          if (onFocus) onFocus(e);
        }}
        onBlur={e => {
          setActive(!!e.target.value);
          if (onBlur) onBlur(e);
        }}
      />
      <i
        className="select-indicator fas fa-chevron-down"
        style={{ paddingRight: '24px' }}
      />
      {tooltip && <TooltipIcon label={label} tooltip={tooltip} />}
    </InputContainer>
  );
};

Select.defaultProps = {};
